import { render, staticRenderFns } from "./RoomBottom.vue?vue&type=template&id=362cd2a2&"
import script from "./RoomBottom.vue?vue&type=script&lang=js&"
export * from "./RoomBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports